<template>
  <el-row class="list-page-content">
    <el-table :data="pageData" style="width: 100%" border size="medium" :height="height" :max-height="maxHeight" v-loading="loading" :header-cell-style="headerCellStyle" :show-summary="showSummary" :summary-method="getSummaries">
      <el-table-column type="index" v-if="showIndex" label="序号" width="50"></el-table-column>
      <el-table-column v-for="(col, index) in cols" :key="index" :label="col.label" :prop="col.prop" :width="col.width ? col.width : ''" :fixed="col.fixed ? col.fixed : false">
        <template v-slot="scope">
          <span v-if="col.clickable" @click="handleClick(scope.row, col.prop)" class="s-action">
            {{ getNestedValue(scope.row, col.prop) }}
          </span>
          <span v-else-if="col.isHtml" v-html="scope.row[col.prop]"></span>
          <component v-else-if="col.component" :is="col.component" :row="scope.row" :prop="col.prop" />
          <span v-else>
            <el-popover
              v-if="col.isNowrap"
              popper-class="pop-class"
              placement="top"
              trigger="click"
              :content="getNestedValue(scope.row, col.prop)">
              <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block; cursor: pointer;" slot="reference">{{ getNestedValue(scope.row, col.prop) }}</span>
            </el-popover>
            <span v-else>{{ getNestedValue(scope.row, col.prop) }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" v-if="showActionColumn">
        <template v-slot="scope">
          <slot name="action" :scope="scope"></slot>
        </template>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
export default {
  name: 'ResourceListPageContent',
  props: {
    pageData: {
      type: Array,
      default: () => {
        return []
      }
    },
    cols: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: String,
      default: 'calc(100vh - 266px)'
    },
    maxHeight: null,
    showActionColumn: {
      type: Boolean,
      default: false
    },
    showIndex: {
      type: Boolean,
      default: false
    },
    showSummary: {
      type: Boolean,
      default: false
    },
    headerCellStyle: Function,
    getSummaries: Function
  },
  components: {
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    getNestedValue (obj, prop) {
      return prop.split('.').reduce((acc, part) => acc && acc[part], obj)
    },
    handleClick (row, prop) {
      this.$emit('cell-click', { row, prop })
    }
  }
}
</script>

<style lang="stylus">
.s-action {
  color: #409EFF;
  cursor: pointer;
}
.is-nowrap {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
}
.pop-class {
  max-width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/common/ResourceListPageContent.vue